import {makeAutoObservable} from 'mobx';
import {loginController} from "./Login/LoginController";
import {signupController} from "./Signup/SignupController";

type CurrentWindow = "LOGIN" | "SIGNUP"

export class LoginSignupController {
  windowVisible = false;
  currentWindow: CurrentWindow = "LOGIN"

  setLoginSignupWindowVisible(visible: boolean) {
    this.windowVisible = visible
  }

  setCurrentWindow(windowVisible: CurrentWindow) {
    this.currentWindow = windowVisible
  }

  get isLoading() {
    return loginController.loading || signupController.loading
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const loginSignupController = new LoginSignupController()
